import { useEffect, useState } from "react";

export const useFetchNewsBySlug = (slug) => {

    const defaultUrl = `${process.env.REACT_APP_API_URL}/api/posts/${slug}`;

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchActusBySlug = async () => {
        setIsLoading(true);

        try {
            const response = await fetch(defaultUrl, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": `${process.env.REACT_API_KEY}`,
            },
            });
            if (!response.ok) {
            throw new Error("Network response was not ok");
            }
            const json = await response.json();
            setData(json.post);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
        };

        fetchActusBySlug();
    }, [defaultUrl]);
    

  return { data, isLoading, error };
}
